import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import BlogCard from "../../Components/BlogCard/BlogCard";
import { config } from "../../config";

function Blogs() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    document.title = config.title;
    getBlogsFromGithubIssues();
  }, []);

  function getBlogsFromGithubIssues() {
    fetch(
      `https://api.github.com/repos/${config.githubUserName}/${config.githubRepo}/issues?labels=blog&state=open&per_page=100`,
      {
        headers: {
          Accept: "application/vnd.github.full+json"
        }
      }
    )
      .then(response => response.json())
      .then(issues => {
        const nodes = issues.map(issue => ({
          title: issue.title,
          body: issue.body,
          bodyHTML: issue.body_html,
          bodyText: issue.body_text,
          number: issue.number,
          labels: {
            nodes: issue.labels.map(label => ({
              color: label.color,
              name: label.name,
              id: label.id.toString()
            }))
          },
          author: {
            url: issue.user.html_url,
            avatarUrl: issue.user.avatar_url,
            login: issue.user.login
          },
          updatedAt: issue.updated_at,
          id: issue.id.toString()
        }));
        setBlogs(nodes);
      })
      .catch(err => console.error(err));
  }

  return (
    <div>
      <Header />
      <div className="blog-div-main">
        {blogs.map((v, i) => {
          return <BlogCard blog={v} key={i} />;
        })}
      </div>
    </div>
  );
}

export default Blogs;
